export default "__VITE_PUBLIC_ASSET__333bc4d3__"